class ItemsChart {
  constructor(table, table_wrapper, {x, y, items = null, mentholPath, imgClick}) {
    this.table = table;
    this.table.style.borderCollapse = 'colloapse';
    this.table_wrapper = table_wrapper;
    this.x = x;
    this.y = y;
    this.items = items;
    this.mentholPath = mentholPath;
    this.#createItemsChart();
    this.table.addEventListener('click', (e) => {
      let target = e.target;
      if(target.tagName == 'IMG') {
        if(!target.classList.contains('img')) return;
        imgClick(target.parentNode);
      }
    });
  }

  // publicメソッド
  // item(img)を配置
  dispositionItem(item) {
    if(item.x > this.x.max || item.y > this.y.max) {
      console.log('xかyが最大値を超えています');
      return;
    }
    if(item.x < this.x.min || item.y < this.y.min) {
      console.log('xかyが最低値を下回ってています');
      return;
    }
    this.#dispositionImg(item);
  }

  // 削除
  delete() {
    let current_tbody = this.table.querySelector('tbody');
    // 無かったら
    if(!current_tbody) {
      console.log('tbodyがありません');
      return;
    };
    current_tbody.remove();
  }

  // 更新（再構築）
  update() {
    this.delete();
    this.#createItemsChart();
  }

  // privateメソッド
  // 構築
  #createItemsChart() {
    // height設定
    this.#setTableWrapperHeight(this.table_wrapper);
    this.#setTableSize(this.table_wrapper);
    this.#setChartDescriptions();
    let tbody = this.#createTableBody();
    this.table.appendChild(tbody);
    if(this.items) {
      this.items.forEach(item => {
        this.dispositionItem(item);
      });
    }
  }

  // テーブルの中身を作成
  #createTableBody() {
    const tbody = document.createElement('tbody');
    const df_tbody = document.createDocumentFragment();
    // 縦(y)のループ
    for (let y_index = this.y.min; y_index < this.y.max; y_index++) {
      const tr = document.createElement('tr');
      tr.classList.add('tr');
      const df_tr = document.createDocumentFragment();

      // 縦の上が0からになるから 下が0になるように
      const y = this.y.max - y_index - 1;

      // 横(x)のループ
      for (let x_index = this.x.min; x_index < this.x.max; x_index++) {
        // td作成
        const td = this.#createTd({
          x: x_index,
          y: y,
          option: {x: this.x, y: this.y},
        });

        // trもどきに追加
        df_tr.appendChild(td);
      }
      // trもどきを使う事でまとめてtdをtrに追加出来る
      tr.appendChild(df_tr);
      df_tbody.appendChild(tr);
    }

    // 装飾
    // let menthol_div = this.#generateMenthol();
    let menthol_div = this.#generateMentholImg();
    // let chart_title = this.#generateChartTitle();
    df_tbody.appendChild(menthol_div);
    // df_tbody.appendChild(chart_title);

    tbody.appendChild(df_tbody);
    return tbody;
  }

  // td作成
  #createTd({x, y, option}) {
    let td = document.createElement('td');

    // widthとheightを指定する
    let td_data = this.#getTdWidthHeight();
    td.style.width = td_data.width + 'px';
    td.style.height = td_data.height + 'px';

    // class追加
    td.classList.add('td');

    // 一番左の行の場合
    if(x == this.x.min) {
      // class追加
      td.classList.add('left');

      // 左上の場合
      if(0 == (option.y.max - y - 1)) {
        td.classList.add('top');
      }
    }

    // 一番下の列の場合
    if(y == this.y.min) {
      // class追加
      td.classList.add('bottom');

      // 右下の場合
      if(0 == (option.x.max - x - 1)) {
        td.classList.add('right');
      }
    }

    return td;
  }

  // z要素を追加
  #generateZ(z) {
    let div = document.createElement('div');
    div.classList.add('zs');
    let td = this.#getTdWidthHeight();
    for (let i = 0; i < z; i++) {
      let img = new Image();
      img.src = this.mentholPath;
      img.classList.add('z');
      img.style.width = (td.width / 8) + 'px';
      img.width = "6.5"
      img.height = "10"
      img.alt = "メンソール"
      div.appendChild(img);
    }
    return div;
  }

  // 商品名を追加
  #generateName(name) {
    let div = document.createElement('div');
    div.classList.add('chart_product_name');
    div.innerHTML = name;
    return div;
  }

  // 画像を生成し配置する
  #dispositionImg({name, x, y, z, zIndex, imgPath, url}) {
    let table = this.table;
    let tbody = table.querySelector('tbody');
    let item = document.createElement('div');
    let itemBottomDiv = document.createElement('div');
    let nameDiv = this.#generateName(name);
    let zs = this.#generateZ(z);
    let img = new Image();
    img.width = '25';
    img.height = '40';
    img.alt = 'フレーバーのパッケージ画像';
    img.dataset.src = imgPath;
    img.classList.add('lazy');
    img.classList.add('img');
    item.classList.add('img_div');
    itemBottomDiv.classList.add('img_div_bottom');
    item.dataset.url = String(url);
    item.appendChild(img);
    itemBottomDiv.appendChild(nameDiv);
    itemBottomDiv.appendChild(zs);
    item.appendChild(itemBottomDiv);

    if(zIndex) {
      item.style.zIndex = zIndex;
    }

    // width height
    let td = this.#getTdWidthHeight();

    item.style.width = (td.width * 1.1) + 'px';
    item.style.left = (td.width * x) + 'px';
    item.style.bottom = (td.height * y) + 'px';

    tbody.appendChild(item);
  }

  // td一個の高さ、横幅を求める
  #getTdWidthHeight() {
    let table = this.table;

    let table_width = table.clientWidth;
    let table_height = table.clientHeight;
    let item_width_unit = table_width / this.x.max;
    let item_height_unit = table_height / this.y.max;

    return {width: item_width_unit, height: item_height_unit};
  }

  // メンソールの説明画像
  #generateMentholImg() {
    let img = new Image();
    img.src = "//richill.life/cdn/shop/t/91/assets/Group%2012.svg?v=70985705487634466611764739314";
    img.classList.add('menthol_img');
    img.alt = "メンソールの説明画像"

    return img;
  }

  // チャートタイトル
  #generateChartTitle() {
    // let div = document.createElement('div');
    // div.textContent = 'FLAVOR CHART'
    // div.classList.add('chart_title');
    let div = new Image();
    div.src = "//richill.life/cdn/shop/t/91/assets/FLAVOR%20CHART.svg?v=157380437113730026611764739313";
    div.classList.add('chart_title_img');
    div.alt = "フレーバーチャートのタイトル"

    return div;
  }

  // チャートの説明をセットする
  #setChartDescriptions() {
    let div1 = new Image();
    div1.src = "//richill.life/cdn/shop/t/91/assets/refresh.svg?v=23821150089059397161764739316";
    div1.classList.add('chart_refresh_img');
    div1.alt = "すっきり"
    let div2 = new Image();
    div2.src = "//richill.life/cdn/shop/t/91/assets/sweet.svg?v=129708731993297418601764739315";
    div2.classList.add('chart_sweet_img');
    div2.alt = "あまさ"

    this.table.appendChild(div1)
    this.table.appendChild(div2)
  }

  // table_wrapperの縦サイズを指定
  #setTableWrapperHeight(element) {
    let width = element.clientWidth;
    let ratio = 0.83;
    if(!isMobile) {
      ratio = 0.56;
    }
    console.log('isMobile: ', isMobile)
    element.style.height = (width * ratio) + 'px';
  }

  // tableサイズ指定
  #setTableSize(tableWrapper) {
    let width = tableWrapper.clientWidth;
    let height = tableWrapper.clientHeight;
    this.table.style.width = (width) + 'px';
    this.table.style.height = (height) + 'px';
  }

  // 拡張子を削除
  static #splitFileExtension(imgPath) {
    let index = imgPath.lastIndexOf('.');
    let data = imgPath.substring(0, index);
    return data;
  }

  // urlの部分を削除
  static #splitSlash(imgPath) {
    let index = imgPath.lastIndexOf('/');
    if(index == -1) return imgPath;
    let newPath = imgPath.slice(index);
    // スラッシュを含めた文字列なので最初の文字（スラッシュ）を消す
    newPath = newPath.slice(1);
    return newPath;
  }

  // pathからデータを生成
  static generateItemData(imgPath) {
    let splitSlashPath = this.#splitSlash(imgPath);
    let newImgPath = this.#splitFileExtension(splitSlashPath);
    let split_array_data = newImgPath.split('_');
    let item_data = {
      x: split_array_data[0],
      y: split_array_data[1],
      z: split_array_data[2],
      backgroundColor: split_array_data[3],
      url: split_array_data[5],
      imgPath: imgPath
    };

    // zIndexの指定があれば
    if(split_array_data[6]) {
      item_data.zIndex = split_array_data[6]
    }

    return item_data;
  }
}
